var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputCircleFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#37A34C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3167 5.90446C15.5076 6.0794 15.5205 6.37591 15.3455 6.56675L8.47054 14.0667C8.38415 14.161 8.26301 14.2159 8.13518 14.2186C8.00736 14.2214 7.88395 14.1719 7.79354 14.0815L4.66854 10.9565C4.48549 10.7734 4.48549 10.4766 4.66854 10.2935C4.8516 10.1105 5.1484 10.1105 5.33146 10.2935L8.11028 13.0724L14.6545 5.93326C14.8294 5.74242 15.1259 5.72953 15.3167 5.90446Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCircleFilledIcon);
export default __webpack_public_path__ + "static/media/inputCircleFilledIcon.0d1e5f2fc8f4d0f7be112e2dead034d0.svg";
export { ForwardRef as ReactComponent };